import React from 'react';

class OptionsButton extends React.Component {
	render () {
		const { onClick, onBlur, children, menuOnLeft, className = 'list-options left' } = this.props;

		return (
			<div className="cell shrink" style={{position: 'relative'}}>
				<button
					className="far fa-ellipsis-v icon"
					onBlur={ onBlur } 
					onClick={ onClick }
					style={{
						width: '25px',
						cursor: 'pointer',
						position: 'absolute',
						top: '-10px',
					}}
				>
				</button>
			</div>
			
		);
	}
}
export default OptionsButton;